import { on_ready, is_elementor_edit } from 'js/utils';
import { init_retina } from 'js/retina';
import { init_toggle_height } from 'js/toggle_height_init';

import { init_header } from 'modules/header/header';
import init_forms from 'modules/forms/forms';
import init_carousels from 'modules/carousel/carousel';
import init_footer from 'modules/footer/footer';
import init_nav_menu from 'modules/menu/nav/nav';

// load global styles
import './main.scss';

on_ready(()=>{

    init_footer();

    if( is_elementor_edit() ) return;
    
    // forms ui + gravityforms customizations
    // move outside of tasks queue, have issues with hooks registered late
    init_forms();

    init_header();

    init_nav_menu();

    init_carousels(); // swiper

    init_retina(); // @images

    init_toggle_height(); // toggle element height from 0 to default - for animating height

    // on_mobile();
    
    init_dynamic_load();

    init_blk_img_animate();

    init_mobile_accordion();

    gf_international_phone();
    
    document.dispatchEvent(new Event('after_main_init'));

});

// function on_mobile(){
//     if( window.innerWidth > 768 ) return;
// }

function init_dynamic_load(){

    // search popup: remove if not used
    // if( document.querySelector('.search_popup_open') ) {
    //     import('modules/search/search_popup/init');
    // }
    
    // burger / mobile menu: remove if not used
    if( document.querySelector('.slide_menu_open') ) {
        import('modules/menu/slide_menu/init');
    }

    // wishlist & compare: remove if not used
    // if( document.querySelector('.compare_count') ||
    //     document.querySelector('.wishlist_count') ) {
    //     import('modules/save_items/init');
    // }
    
    // cookie consent
    // if( !get_cookie('ff_cookie_consent') ) {
    //     import('modules/cookie_consent/simple/simple')
    // }
}

function init_blk_img_animate() {
    const blocks = document.querySelectorAll('.blk-img-animate');
    if (!blocks.length) return;

    blocks.forEach((block, index) => {
       
        const isEven = index % 2 === 0;
        block.classList.add(isEven ? 'from-right' : 'from-left');

        block.addEventListener('mouseenter', () => {
            if (window.innerWidth > 767) {
                block.classList.add('active');
            }
        });
    });
}

function init_mobile_accordion() {
    const is_mobile = window.innerWidth < 768;
    if (!is_mobile || typeof jQuery === 'undefined') return;

    const $ = jQuery;

    jQuery(window).on('elementor/frontend/init', function() {
        
        setTimeout(() => {
            $('.e-n-accordion-item[open]').each(function() {
                this.removeAttribute('open');
                $(this).find('summary').attr({
                    'aria-expanded': 'false'
                });
            });
        }, 300);
    });
}

//GForm Restrict Letters in Phone Field
function gf_international_phone() {
    const phoneInputs = document.querySelectorAll(
        '.gfield--type-phone input[type="tel"]'
    );
    if (!phoneInputs.length) return;
    phoneInputs.forEach(input => {
        // prevent duplicate bindings
        if (input.dataset.intlPhoneBound) return;
        input.dataset.intlPhoneBound = 'true';
        // Block invalid keys BEFORE typing
        input.addEventListener('keydown', function (e) {
            const allowedKeys = [
                'Backspace',
                'Delete',
                'ArrowLeft',
                'ArrowRight',
                'Tab',
                'Home',
                'End'
            ];
            if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) return;
            // Allow numbers
            if (/^[0-9]$/.test(e.key)) return;
            // Allow + only if cursor at start and not already present
            if (e.key === '+' && this.selectionStart === 0 && !this.value.startsWith('+')) return;
            e.preventDefault();
        });
        // Sanitize pasted content / input
        input.addEventListener('input', function () {
            let value = this.value;
            // Remove everything except digits, +, and optional space
            value = value.replace(/[^0-9+ ]/g, '');
            // Ensure only ONE + at the start
            if (value.startsWith('+')) {
                value = '+' + value.slice(1).replace(/\+/g, '');
            } else {
                value = value.replace(/\+/g, '');
            }
            this.value = value;
        });
    });
}